module.exports = new __parcel__URL__("sweepingrevenge.1d707150.png").toString();